module.exports = __webpack_public_path__ + "static/media/TopScorerComponent_elCertificate1_542954.f2bc6d11.png";